<template>
  <q-icon
    v-if="currentIcon"
    :size="size"
    :class="className"
    :data-icon="icon"
    :color="color"
  >
    <component :is="currentIcon" />
  </q-icon>
</template>

<script setup>
import { shallowRef, watchEffect } from "vue";
//props
const props = defineProps({
  icon: {
    type: String,
    default: "arrow-down",
  },
  size: {
    type: String,
    default: "",
  },
  className: {
    type: [String, Array],
    default: "",
  },
  color: {
    type: String,
    default: "",
  },
});

const currentIcon = shallowRef("");

import(`./svg-icons/${props.icon}.vue`).then((val) => {
  currentIcon.value = val.default;
});

watchEffect(() => {
  import(`./svg-icons/${props.icon}.vue`).then((val) => {
    currentIcon.value = val.default;
  });
});
</script>
